module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00471.bebc7834.jpg";